import { h } from "preact";
import { useContext, useState } from "preact/hooks";
import { Context } from "../lib/globalState";

export default function Header({ visible, onClick, loader, online }) {
  const {
    state: { color },
  } = useContext(Context);

  const [isHover, setHover] = useState(false);

  if (!loader) {
    return (
      <div
        className="load-comments"
        style={isHover && `border-color: ${color}`}
        onClick={() => onClick(!visible)}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      >
        <img src={require("../assets/images/load-comments.svg")} height="28" />
        <span className="load-comments-prompt">
          View comments on this story
        </span>
        <div className="loader-wrapper">
          <div
            className="lds-ellipsis"
            id="loader"
            style={`display: ${
              loader || !visible || !online ? "none" : "show"
            }`}
          >
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      </div>
    );
  }

  return null;
}
